import { SIGN_IN } from 'dealer-reducers'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EstigroupLogoSvg from '../other/svg/EstigroupLogoSvg'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RootReducer } from 'src/redux/rootReducer'
import MobileRedirect from '../atoms/MobileRedirect'
import GoogleSignInButton from '../atoms/GoogleSignInButton'
import SignInButton from '../atoms/SignInButton'
import PasswordInput from '../atoms/PasswordInput'

const SignIn = (): JSX.Element => {
  const { t } = useTranslation()
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const dispatch = useDispatch()
  const signInError = useSelector((state: RootReducer) => state.authReducer.signInError)
  const isLoading = useSelector((state: RootReducer) => state.authReducer.isLoading)

  return (
    <>
      <div className="w-screen h-screen pt-20 pb-9 bg-gradient-to-b from-sky-700 to-sky-800 inline-flex justify-center items-center gap-2.5">
        <div className="w-96 px-9 inline-flex flex-col justify-center items-start gap-16">
          <div className="w-full flex justify-center items-center">
            <EstigroupLogoSvg className=" text-white" />
          </div>

          <div className="w-full max-w-96 flex flex-col justify-center items-center gap-6">
            <div className="self-stretch text-center justify-center text-white text-xl font-semibold font-Montserrat leading-6">
              {t('sign_in_screen.title')}
            </div>

            <div className="self-stretch flex flex-col justify-start items-start gap-8">
              <div className="self-stretch flex flex-col justify-start items-start gap-2">
                <div className="justify-center text-white text-sm font-medium font-Montserrat leading-5">E-mail</div>
                <div
                  className="self-stretch px-4 py-3 bg-white rounded-md inline-flex justify-start items-center gap-1 overflow-hidden"
                  style={{
                    boxShadow: '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
                  }}>
                  <input
                    type="text"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value)
                    }}
                    className="w-60 justify-start outline-none bg-transparent text-gray-900"
                    placeholder=""
                  />
                </div>
              </div>

              <div className="self-stretch flex flex-col justify-start items-start gap-2">
                <div className="self-stretch inline-flex justify-between items-start">
                  <div className="justify-center text-white text-sm font-medium font-Montserrat leading-5">
                    {t('sign_in_screen.password')}
                  </div>
                  <Link
                    to="/reset-password"
                    className="justify-start text-blue-300 text-xs font-medium font-Montserrat underline leading-5 hover:text-blue-200">
                    {t('sign_in_screen.forgot_password')}
                  </Link>
                </div>
                <PasswordInput
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value)
                  }}
                  showPassword={showPassword}
                  onTogglePassword={() => {
                    setShowPassword(!showPassword)
                  }}
                />
                {signInError && (
                  <div className="text-red-400 font-medium text-sm relative top-1">
                    {t('sign_in_screen.password_invalid')}
                  </div>
                )}
              </div>
            </div>

            <SignInButton
              onClick={() => {
                dispatch(SIGN_IN({ password, email }))
              }}
              disabled={isLoading}
              isLoading={isLoading}
              text={t('sign_in_screen.sign_in')}
            />

            <div className="self-stretch flex flex-col justify-start items-start gap-6">
              <div className="self-stretch inline-flex justify-center items-center gap-3">
                <div className="flex-1 h-px bg-white/10" />
                <div className="justify-start text-white text-sm font-medium font-Montserrat">or</div>
                <div className="flex-1 h-px bg-white/10" />
              </div>
              <GoogleSignInButton />
            </div>
          </div>
        </div>
      </div>
      <MobileRedirect />
    </>
  )
}

export default SignIn
